var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layoutName,{key:_vm.layoutName,tag:"component",staticClass:"layout"}),_c('dialogs-wrapper',{attrs:{"tag":"div"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }